import React from 'react';
import { Input, Select, Button } from 'semantic-ui-react';
import { churchServices, formSelectService } from '../../components/helpers';
import eventService from '../../services/api/eventService';
import { GuestIdFormComp } from '../../assets/styles/components/CheckIn';

const GuestIdForm = (props) => {
  const {
    guestID,
    set_guestID,
    getAttendant,
    loadedData,
    errorData,
    text,
    title,
    history,
    showEventSelect = false,
    eventSN,
    onEventSNChange,
  } = props;
  const [previousEventsNames, set_previousEventsNames] = React.useState(churchServices);
  const [loading, set_loading] = React.useState(false);

  const selectHandle = (a, { value }) => {
    if (typeof onEventSNChange === 'function') {
      onEventSNChange(value);
      return;
    }
    history.push(`/checkin/servicio?eventSN=${value}`);
  };

  React.useEffect(() => {
    if (!showEventSelect) return;
    getPreviousEventNames();
  }, [showEventSelect]);

  const getPreviousEventNames = () => {
    set_loading(true);
    eventService
      .getEventsNames({ postDays: 5 })
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          set_previousEventsNames(response.data.eventsNames);
        }
      })
      .catch(() => {
        set_loading(false);
      });
  };

  return (
    <GuestIdFormComp>
      {title && <h1 className="GuestIdForm__title">{title}</h1>}
      {text && <h4 dangerouslySetInnerHTML={{ __html: text }} style={{ textAlign: 'center' }} />}
      <form onSubmit={(e) => getAttendant(e)} className="">
        {showEventSelect && (
          <div>
            {formSelectService({
              Select,
              label: 'Auditorio',
              name: 'eventSlugname',
              handler: selectHandle,
              value: eventSN || '',
              loading,
              style: { width: '100%' },
              options: previousEventsNames,
            })}
          </div>
        )}
        <Input
          autoFocus
          placeholder="Identificación"
          type="number"
          loading={loading}
          min={0}
          className="Registration__input Registration__input-id"
          value={guestID}
          style={{ width: '100%' }}
          onChange={(e) => set_guestID(e.target.value)}
        />
        {errorData && <p style={{ color: 'red', textAlign: 'center' }}>{errorData}</p>}
        <Button type="submit" style={{ width: '100%' }} disabled={loadedData}>
          Ver
        </Button>
      </form>
    </GuestIdFormComp>
  );
};

export default GuestIdForm;
